<div class="main-content">
  <div class="container-fluid">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header card-header-danger">
                  <h4 class="card-title">ADD NEW DEPARTMENT </h4>
                  <p class="card-category">ALL DEPARTMENTS </p>
              </div>
              <div class="card-body">
                  <form [formGroup]="AddDepartmentForm">
                      <div class="row">
                          <div class="col-md-12">
                    
                              <mat-form-field class="example-full-width">
                                <input matInput placeholder="Department Name" 
                                formControlName="Name"   >
                              </mat-form-field>
                          </div>
            
                      </div>

                      <button *ngIf="!update" mat-raised-button type="submit" class="btn primary"
                      [disabled]="AddDepartmentForm.invalid" (click)="Submit()">Add Department</button>
                      
                      <button  *ngIf="update" mat-raised-button type="submit" class="btn primary"
                      [disabled]="AddDepartmentForm.invalid" (click)="Submit()">Update Department</button>
                  </form>
                  <mat-form-field>
                      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                  </mat-form-field>

                  <table mat-table [dataSource]="Departments" class="mat-elevation-z8">

                      <!-- Position Column -->
                      <ng-container matColumnDef="ID">
                          <th mat-header-cell *matHeaderCellDef> ID </th>
                          <td mat-cell *matCellDef="let element"> {{element.id}}
                          </td>
                      </ng-container>

                      <!-- Name Column -->
                      <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef>Name</th>
                          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                      </ng-container>

                      <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            
                            <button mat-raised-button (click)="Edit(element)"><i class="material-icons">
                              edit
                          </i></button>
                              <button mat-raised-button (click)="DeleteDepartment(element)"><i class="material-icons">
                                      delete
                                  </i></button>

                          </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
              </div>
          </div>
      </div>
  </div>
</div>